// Channel-Specific Configuration Support: reads the currently-selected channel
// fresh on every call (not cached at import time, unlike authToken.js's token -
// deliberately not repeating that staleness pattern here) so switching channels
// takes effect on the very next request.
export const getChannelId = () => {
	try {
		const state = window?.store?.getState ? window.store.getState() : null
		return state?.currentChannelId ?? localStorage.getItem('channel_id') ?? null
	} catch (e) {
		return localStorage.getItem('channel_id') ?? null
	}
}

export const withChannelHeader = (config = {}) => {
	const channelId = getChannelId()
	if (!channelId) {
		return config
	}
	return {
		...config,
		headers: {
			...(config.headers || {}),
			'X-Channel-Id': channelId,
		},
	}
}

// Error Handling (SRS section 11): the backend's channel-resolution middleware returns
// these two exact messages with a 422 for an invalid or deleted channel. Recognizing them
// here means the recovery (surface a message, drop back to the default channel) is shared
// by every axios call site in the app, rather than something each page has to handle itself.
const CHANNEL_ERROR_MESSAGES = [
	'Selected channel configuration could not be loaded.',
	'This channel no longer exists in BigCommerce.',
]

export const handleChannelErrorResponse = error => {
	const status = error?.response?.status
	const message = error?.response?.data?.message
	if (status !== 422 || !CHANNEL_ERROR_MESSAGES.includes(message)) {
		return false
	}

	try {
		localStorage.removeItem('channel_id')
	} catch (e) {}

	const store = window?.store
	if (store?.dispatch) {
		store.dispatch({ type: 'SET_CURRENT_CHANNEL', payload: null })
		store.dispatch({
			type: 'ALERT_MESSAGE',
			payload: {
				showAlertMessage: true,
				alertMessageType: 'error',
				alertMessage: message + ' Switching back to the default channel.',
			},
		})
	}

	// A fresh load re-resolves the default channel (App.js/ChannelSelector) and
	// re-fetches every channel-scoped page's data under it - the same mechanism
	// already used for a normal channel switch.
	window.location.reload()
	return true
}
